/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { Suspense, useEffect, useState } from "react";
import axios from "axios";
import localData from "./Home.json";
import AnglTokenBanner from "../../components/MainPage/AnglTokenBanner/AnglTokenBanner";
// import HeaderMobile from "../../components/MainPage/HeaderMobile/HeaderMobile";

import Navbar from "../../components/MainPage/Navbar/navbar";
import FadeInSection from "../../components/FadeinEffectSection/FadeInEffect";



const Airevolutionizing = React.lazy(() =>
  import("../../components/MainPage/Airevolutionizing/Airevolutionizing")
);


const AngelAIandTwinProtocol = React.lazy(() =>
  import("../../components/MainPage/AngelAI&TwinProtocol")
);

const Aidrivensocial = React.lazy(() =>
  import("../../components/MainPage/Aidrivensocial/Aidrivensocial")
);

const Anglutility = React.lazy(() =>
  import("../../components/MainPage/Anglutility/Anglutility")
);

// const Angltokenomics = React.lazy(() =>
//   import("../../components/MainPage/Angltokenomics/Angltokenomics")
// );

const Aineedangl = React.lazy(() =>
  import("../../components/MainPage/Aineedangl/Aineedangl")
);

const Aiengagement = React.lazy(() =>
  import("../../components/MainPage/Aiengagement/Aiengagement")
);

const LatestBlogs = React.lazy(() =>
  import("../../components/MainPage/Blog/LatestBlogs/Blogs")
);

const MakeAIYours = React.lazy(() =>
  import("../../components/MainPage/AngelAI&TwinProtocol/MakeAIYours")
);

const FooterNew = React.lazy(() =>
  import("../../components/FooterNewChanges/FooterNewChanges")
);

function Home() {
  const [showOtherComponents, setShowOtherComponents] = useState(false);
  const [homeData, setHomeData] = useState(localData);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 991.9);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 20) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the scroll listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures the effect runs only once, like componentDidMount

  useEffect(() => {
    const fetchAngelAiJSON = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_CDN_LINK}angeltwin/jsons/Home.json?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setHomeData(response.data); // Set the remote data if the fetch is successful
      } catch (error) {
        console.error(
          "Error fetching remote JSON. Falling back to local JSON.",
          error
        );
        // Fallback to local data already set in the state
      }
    };
    fetchAngelAiJSON();
  }, []);

  // Effect to handle window resize and update screen size state
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 991.9);
    };

    window.addEventListener("resize", handleResize);

    // Clean up the resize listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      <div className="background-wholepage">
        <Navbar mainPage={true} />


        <FadeInSection>
          <AnglTokenBanner mainPage={true} configData={homeData} />
        </FadeInSection>




        <FadeInSection>
          <Suspense fallback={<div>Loading...</div>}>
            <Airevolutionizing />
          </Suspense>
        </FadeInSection>

      </div>

      {showOtherComponents && (
        <>

          <FadeInSection>
            <Suspense fallback={<div>Loading...</div>}>
              <AngelAIandTwinProtocol />
            </Suspense>
          </FadeInSection>

          {/* <FadeInSection>
            <Suspense fallback={<div>Loading...</div>}>
              <Aidrivensocial />
            </Suspense>
          </FadeInSection> */}

          {/* <div className="background-wholepage">
            <FadeInSection>
              <Suspense fallback={<div>Loading...</div>}>
                <Anglutility />
              </Suspense>
            </FadeInSection>
          </div> */}

          {/* <FadeInSection>
            <Suspense fallback={<div>Loading...</div>}>
              <Angltokenomics />
            </Suspense>
          </FadeInSection> */}



          <div className="background-blogpage">
            <FadeInSection>
              <Suspense fallback={<div>Loading...</div>}>
                <LatestBlogs />
              </Suspense>
            </FadeInSection>
          </div>
          {/* <div className="background-wholepage">
            <FadeInSection>
              <Suspense fallback={<div>Loading...</div>}>
                <Aineedangl />
              </Suspense>
            </FadeInSection>
          </div> */}
          {/* 
          <FadeInSection>
            <Suspense fallback={<div>Loading...</div>}>
              <Aiengagement />
            </Suspense>
          </FadeInSection> */}
          <FadeInSection>
            <Suspense fallback={<div>Loading...</div>}>
              <MakeAIYours />
            </Suspense>
          </FadeInSection>
          <Suspense fallback={<div>Loading...</div>}>
            <FooterNew />
          </Suspense>

        </>

      )
      }

    </div >
  );
}
export default Home;
